import React from "react";

import { ReactComponent as PaperCheckIcon } from "assets/svgs/paper-check-icon.svg";
import { ReactComponent as DetectionIcon } from "assets/svgs/detection-icon.svg";
import { ReactComponent as ShieldCheckIcon } from "assets/svgs/shield-check-icon.svg";
import { ReactComponent as PlanningReportIcon } from "assets/svgs/planning-report-icon.svg";

import * as S from "./SectionIntergrityProgram.Style";

const programList = [
  {
    id: 1,
    icon: PaperCheckIcon,
    title: "Prevenção",
    description:
      "Conjunto de mecanismos que identifica, avalia e mitiga os riscos de integridade.",
  },
  {
    id: 2,
    icon: DetectionIcon,
    title: "Detecção",
    description:
      "Encontra e interrompe desvio de conduta que não tenha sido evitado pelas ações de prevenção. Possibilita a responsabilização dos envolvidos.",
  },
  {
    id: 3,
    icon: ShieldCheckIcon,
    title: "Remediação",
    description:
      "Estabelece a responsabilidade e a sanção, quando aplicável, ao caso de desvio de conduta comprovado, atua na recuperação de eventuais prejuízos e possibilita a mitigação das fragilidades.",
  },
  {
    id: 4,
    icon: PlanningReportIcon,
    title: "Monitoramento",
    description:
      "Garante que todas as práticas e medidas de integridade sejam acompanhadas de forma contínua e eficaz. Verifica se as políticas de integridade estão sendo seguidas.",
  },
];

const SectionIntergrityProgram = () => {
  return (
    <S.SectionIntergrityProgramContainer className="container">
      <S.SectionIntergrityProgramContent>
        <S.SectionIntergrityProgramTitle>
          Programa de Integridade
        </S.SectionIntergrityProgramTitle>

        <S.SectionIntergrityProgramText>
          <p>
            Em 2024, também lançamos nosso Programa de Integridade, que define
            ações para prevenir, detectar, monitorar e corrigir atos ilícitos e,
            assim, combater a corrupção. Por meio dele, garantimos a ética, a
            transparência e o cumprimento de leis e regulamentos vigentes, como
            a Lei Anticorrupção (nº 12.846/2013) e decreto nº 11.129/2022, bem
            como a resolução nº 416/2021 do Conselho Nacional de Seguros
            Privados (CNSP).{" "}
          </p>

          <p>
            Além disso, seguimos nosso Código de Ética e Conduta, com o apoio da
            alta gestão, e promovemos iniciativas ESG, baseadas em práticas
            sociais, ambientais e, especialmente, de governança, realizando
            treinamentos e campanhas internas que reforçam nossos valores.
          </p>
        </S.SectionIntergrityProgramText>
      </S.SectionIntergrityProgramContent>

      <S.SectionIntergrityProgramContent>
        <S.SectionIntergrityProgramTitle>
          Eixos do Programa{" "}
        </S.SectionIntergrityProgramTitle>

        <S.SectionIntergrityProgramList>
          {programList.map((programItem) => (
            <S.SectionIntergrityProgramItem key={programItem.id}>
              <programItem.icon />

              <S.SectionIntergrityProgramItemContent>
                <S.SectionIntergrityProgramItemTitle>
                  {programItem.title}
                </S.SectionIntergrityProgramItemTitle>

                <S.SectionIntergrityProgramItemDescription>
                  {programItem.description}
                </S.SectionIntergrityProgramItemDescription>
              </S.SectionIntergrityProgramItemContent>
            </S.SectionIntergrityProgramItem>
          ))}
        </S.SectionIntergrityProgramList>
      </S.SectionIntergrityProgramContent>
    </S.SectionIntergrityProgramContainer>
  );
};

export default SectionIntergrityProgram;
